export default __webpack_public_path__ + "static/media/contact.0509dedc.jpg";